import styled from './CustomLoading.module.scss';


export function CustomLoading() {

  return(
    <div className={styled.loadingWrapper}>
      <div className={styled.loadingWrapper_loading}/>
    </div>
  );
}
